export enum EDisplayState {
    HIDDEN = 'hidden',
    VISIBLE = 'visible',
}

export enum EDisplayConditionType {
    ALWAYS = 'always',
    URL = 'url_parameter',
    DATE = 'date',
    TIME = 'time',
    WEEKDAY = 'weekday',
    AUTH_EDU = 'student_authorization',
    GROUP_EDU = 'student_group',
}

export enum EDisplayConditionOperator {
    OR = 'or',
    AND = 'and',
}

export enum EEqualityType {
    EQUAL = 'equal',
    NOT_EQUAL = 'not_equal',
    CONTAINS = 'contains',
}